<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div>
    <confirm-dialog ref="confirm">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
          style="color: white" @click="confirmDialogConfirm800Function()" :disabled="disabelConfirm">
          بله
        </v-btn>
        <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
          @click="confirmDialogCancel800Function()">
          خیر
        </v-btn>
      </v-row>
    </confirm-dialog>
    <v-dialog v-model="cancelHospitalModal" width="450" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-hospital-building</v-icon>
              <span class="modal-title-text mr-2">لغو بیمارستان</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-5">
          <v-row>
            <v-col cols="12">
              <v-textarea dense outlined rows="5" clearable clear-icon="mdi-close-circle-outline" label="توضیحات"
                v-model="missionInformation.hospitalCancelReason" prepend-inner-icon="mdi-text mdi-18px"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="setCancelHospital()" dark rounded class="normal-letter-spacing px-12">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelSetCancelHospital()"
            class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog width="450" v-model="tenNineteenModal" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-3">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-ambulance mdi-flip-h</v-icon>
              <span class="modal-title-text mr-2">10-19</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-8">
          <v-row>
            <v-col cols="12">
              <v-autocomplete hide-details :items="allCancelReasonsForOther" no-data-text="اطلاعاتی وجود ندارد"
                tabindex="1" dense outlined clearable clear-icon="mdi-close-circle-outline" item-text="note"
                item-value="value" label="علل 19-10" :autofocus="true" v-model="editMissionSelectedCancleReason"
                autocomplete="off" prepend-inner-icon="mdi-ambulance mdi-18px"
                @change="setCancelReasonNote()"></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-textarea hide-details outlined prepend-inner-icon="mdi-text mdi-18px" clearable
                clear-icon="mdi-close-circle-outline" tabindex="2" label="توضیحات" rows="5"
                v-model="editMissionTenNineteenNote"></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-btn color="darkColor" @click="setCancelReasonFor800MissionFunction()" dark rounded block
                class="normal-letter-spacing">
                ثبت
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn rounded color="darkColor" outlined @click="cancelSetCancleReaonFor800Mission()"
                class="normal-letter-spacing px-10">انصراف از ثبت 19-10</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- <v-card-actions class=""> -->
        <!-- </v-card-actions> -->
      </v-card>
    </v-dialog>
    <v-row no-gutters>
      <v-col cols="12">
        <!-- height="80vh" -->
        <v-card class="edit-mission-main-card">
          <v-row no-gutters>
            <v-col cols="12" class="modal-header py-5">
              <v-row no-gutters>
                <v-col cols="1">
                  <span class="phone-code">کد {{ phoneCode }}</span>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="9" class="mt-3">
                  <div class="menu_topBox">
                    <div class="itemMenu ">
                      <span :class="editInfoTabClass" @click="changeTab('edit')">ویرایش اطلاعات</span>
                    </div>
                    <div class="itemMenu ">
                      <span :class="timeTabClass" @click="changeTab('time')">زمان ها و وضعیت</span>
                    </div>
                    <div class="itemMenu ">
                      <span :class="doctorInsideTabClass" @click="changeTab('doctor')">
                        دستورات پزشکی
                      </span>
                    </div>
                    <div class="itemMenu ">
                      <span :class="moreTabClass" @click="changeTab('moreInfo')">سایر اطلاعات</span>
                    </div>
                    <div class="itemMenu ">
                      <span :class="otherOrganTabClass" @click="changeTab('otherOrgan')">
                        سازمان های همکار
                      </span>
                    </div>
                    <div class="itemMenu ">
                      <span :class="noteTabClass" @click="changeTab('note')">توضیحات</span>
                    </div>
                    <div class="itemMenu ">
                      <span :class="addressTabClass" @click="changeTab('address')">
                        سابقه آدرس و موقعیت جغرافیایی
                      </span>
                    </div>
                    <div class="itemMenu ">
                      <span :class="callTabClass" @click="changeTab('calls')">
                        تماس ها
                      </span>
                    </div>
                  </div>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="1" class="text-left mt-n2 ml-2">
                  <v-icon color="darkColor" @click="closeMissionEditModal()">mdi-close</v-icon>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-card-text class="mt-3">
            <v-row no-gutters>
              <v-col cols="12" v-if="editTab == 'edit'">
                <v-row>
                  <span class="mr-3">ویرایش اطلاعات</span>
                  <v-divider class="mr-2 mt-3"></v-divider>
                </v-row>
                <v-row>
                  <!-- 10-19 -->
                  <v-col cols="4">
                    <v-autocomplete hide-details :items="allDispatchCodesForOther" no-data-text="اطلاعاتی وجود ندارد"
                      dense outlined clearable clear-icon="mdi-close-circle-outline" item-text="title"
                      item-value="value" label="وضعیت ماموریت" v-model="missionInformation.dispatchCurrentState"
                      @change="changeDispatchCurrentState" autocomplete="off"
                      prepend-inner-icon="mdi-file-document mdi-18px" style="font-size: 11px !important">
                      <template v-slot:append-outer>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn color="darkColor" v-bind="attrs" v-on="on" @click="showConfirmLastStateModal()"
                              elevation="0" small :disabled="!hasStatusFlag" class="p-0 brnAction">
                              <v-icon color="white" size="14">mdi-reload</v-icon>
                            </v-btn>
                          </template>
                          <span>ارسال مجدد آخرین وضعیت</span>
                        </v-tooltip>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="4">
                    <v-autocomplete hide-details :items="allActiveHospitals" no-data-text="اطلاعاتی وجود ندارد" dense
                      outlined clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id"
                      label="بیمارستان" @change="hospitalChange()" autocomplete="off"
                      v-model="missionInformation.hospitalId" prepend-inner-icon="mdi-hospital-building mdi-18px"
                      style="font-size: 11px !important">
                      <template v-slot:append-outer>
                        <v-btn color="darkColor" @click="showCancelHospitalModal()" elevation="0" small
                          :disabled="!hasHospitalFlag" class="p-0 brnAction">
                          <v-icon color="white" size="14">mdi-close</v-icon>
                        </v-btn>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="4">
                    <v-autocomplete hide-details :items="allTagsForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                      outlined clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id"
                      multiple label="برچسب ها" autocomplete="off" v-model="missionInformationTagList"
                      prepend-inner-icon="mdi-tag mdi-18px" style="font-size: 11px !important"></v-autocomplete>
                  </v-col>
                  <v-col cols="2" class="mt-n2">
                    <v-autocomplete hide-details :items="allZones" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                      clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id" label="ناحیه"
                      autocomplete="off" v-model="missionInformation.dispatchZoneId"
                      prepend-inner-icon="mdi-map mdi-18px" style="font-size: 11px !important"></v-autocomplete>
                  </v-col>
                  <v-col cols="2" class="mt-n2">
                    <v-autocomplete hide-details :items="allCitysForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                      outlined clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id"
                      label="شهر" autocomplete="off" v-model="missionInformation.cityId"
                      prepend-inner-icon="mdi-home-city mdi-18px" style="font-size: 11px !important"></v-autocomplete>
                  </v-col>
                  <v-col cols="8" class="mt-n2">
                    <v-text-field hide-details dense outlined clearable clear-icon="mdi-close-circle-outline"
                      label="آدرس" autocomplete="off" v-model="missionInformation.address"
                      prepend-inner-icon="mdi-map-marker mdi-18px"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <v-row>
                      <span class="mr-3">شماره های تلفن</span>
                      <v-divider class="mt-2 mr-3 ml-2"></v-divider>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-card elevation="0" class="edit-modal-card-detail edit-modal-phones-card" height="25vh">
                          <v-card-text>
                            <section class="flex flex-wrap gap-1 justify-between">
                              <div v-for="(item, index) in listOfMissionCallerIds" :key="index">
                                <div class="phone-numbers-items mt-2 ml-2 flex items-center justify-between">
                                  {{ item }}
                                  <v-icon @click="callToPatient(item)" color="white"
                                    class="phone-numbers-items-icon mr-3">
                                    mdi-phone mdi-18px
                                  </v-icon>
                                </div>
                              </div>
                            </section>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="4">
                    <v-row>
                      <span class="mr-3">مناطق فاقد کد</span>
                      <v-divider class="mt-2 mr-3 ml-2"></v-divider>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-card elevation="0" class="edit-modal-card-detail edit-modal-phones-card" height="25vh">
                          <v-card-text>
                            <v-row>
                              <v-col cols="10" class="mt-n1">
                                <v-autocomplete hide-details :items="allStationsWithoutCode"
                                  no-data-text="اطلاعاتی وجود ندارد" dense item-text="titleCode" item-value="id"
                                  placeholder="انتخاب کد" return-object autocomplete="off" auto-select-first
                                  v-model="selectedMissionLakeCode" @keydown.enter="handleEnterLack()"></v-autocomplete>
                              </v-col>
                              <v-col cols="2" class="mr-n2">
                                <v-btn color="darkColor" small class="py-3" block elevation="0"
                                  @click="addMissionLakeCode()">
                                  <v-icon color="white">mdi-plus mdi-18px</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                            <v-chip close close-icon="mdi-close" class="mr-2 mt-2"
                              @click:close="removeMissionLakeCode(item.id)" small
                              v-for="item in listOfMissionLakeCodeStation" :key="item.id">
                              {{ item.titleCode }}
                            </v-chip>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="4">
                    <v-row>
                      <span class="mr-3">اطلاعات بیشتر</span>
                      <v-divider class="mt-2 mr-3 ml-2"></v-divider>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-autocomplete hide-details :items="allGeographicalTypes" no-data-text="اطلاعاتی وجود ندارد"
                          dense outlined clearable clear-icon="mdi-close-circle-outline" item-text="title"
                          item-value="id" label="نوع ماموریت" v-model="missionInformation.geographicalTypeId"
                          autocomplete="off" prepend-inner-icon="mdi-file-document mdi-18px"
                          style="font-size: 11px !important"></v-autocomplete>
                      </v-col>
                      <v-col cols="6" class="mt-n7">
                        <v-checkbox v-model="missionInformation.allow1019" @click="onAccept1019" label="تایید 19-10"
                          hide-details></v-checkbox>
                      </v-col>
                      <v-col cols="6" class="mt-n7">
                        <v-checkbox v-model="missionInformation.isDeployed" label="استقرار" hide-details></v-checkbox>
                      </v-col>
                      <!--<v-col cols="6" class="mt-n3">
                        <v-checkbox
                          v-model="missionInformation.isWithinCity"
                          label="برون شهری"
                          hide-details
                        ></v-checkbox>
                      </v-col>-->
                      <v-col cols="6" class="mt-n7">
                        <v-checkbox v-model="missionInformation.editableByFollowUp" label="ثبت توسط پیگیری"
                          hide-details></v-checkbox>
                      </v-col>
                      <v-col cols="6" class="mt-n7">
                        <v-checkbox v-model="missionInformation.is247" label="کد 247" hide-details></v-checkbox>
                      </v-col>
                      <v-col cols="6" class="mt-n7">
                        <v-checkbox v-model="missionInformation.is724" label="کد 724" hide-details></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-spacer></v-spacer>
                  <v-btn rounded dark color="darkColor" class="px-14 ml-6 mt-2 mb-2"
                    @click="modifyMissionBy800UserFunction()">
                    ثبت
                  </v-btn>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="editTab == 'time'">
                <v-row>
                  <v-col cols="12" class="mb-9">
                    <v-row>
                      <span>زمان ها</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="mt-n3">
                    <v-row>
                      <v-col v-for="item in missionTimes" :key="item.id" :cols="item.size">
                        <user-detail-component has-icon v-if="item.title" :title="item.title" :size="item.size"
                          :text="item.text" :icon="item.icon" :per="item.per" :perKey="item.perKey"
                          :secondText="item.secondText"></user-detail-component>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="mt-4">
                    <v-row>
                      <span class="mr-3">وضعیت ها</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="">
                    <edit-dialog-information-component v-if="editTab == 'time'" :tableHeader="stateDataTableHeader"
                      :tableItems="stateDataTableItems" :height="'30vh'"></edit-dialog-information-component>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="editTab == 'note'">
                <v-row>
                  <span>توضیحات</span>
                  <v-divider class="mt-2 mr-3"></v-divider>
                </v-row>
                <v-row>
                  <v-col cols="12" class="note-component-space mt-n4">
                    <v-row>
                      <v-col cols="12" v-for="item in noteList" :key="item.id" class="mb-5">
                        <dispatch-note-component :user="item.user" :date="item.date"
                          :note="item.note"></dispatch-note-component>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-card elevation="0" height="17vh" class="note-box">
                      <v-row>
                        <v-col cols="2" class="not-box-title">
                          <span>افزودن توضیحات</span>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>

                      <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="12" class="note-box-input">
                          <v-row>
                            <v-spacer></v-spacer>
                            <v-col cols="11">
                              <v-textarea outlined prepend-inner-icon="mdi-text mdi-18px" rows="2"
                                @keydown="noteHandler" clearable clear-icon="mdi-close-circle-outline"
                                placeholder="توضیحات" v-model="noteText"></v-textarea>
                            </v-col>
                            <v-spacer></v-spacer>
                          </v-row>
                          <v-row>
                            <v-col cols="12" class="mt-n10">
                              <v-row>
                                <v-spacer></v-spacer>
                                <v-btn color="lightColor" @click="addNote()" class="ml-4 normal-letter-spacing" text>
                                  <v-icon color="lightColor">mdi-check mdi-18px</v-icon>
                                  ثبت توضیحات
                                </v-btn>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="editTab == 'address'">
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="6">
                        <v-row>
                          <span>نقشه</span>
                          <v-divider class="mt-3 mr-2 ml-2"></v-divider>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <div id="map">
                              <l-map v-if="isMapReadyToShow" ref="modalmap" style="height: 60vh !important" :zoom="zoom"
                                :center="center" :options="mapOptions" @click="addPationtNewPositionMarker"
                                @update:center="centerUpdate" @update:zoom="zoomUpdate" @ready="mapInvalidate()">
                                <l-tile-layer :url="mapTileUrl" :attribution="attribution"></l-tile-layer>
                                <l-control position="bottomleft">
                                  <v-btn small rounded dark color="darkColor" class="no-letter-space"
                                    @click="showLine()">
                                    مشاهده مسیر
                                  </v-btn>
                                </l-control>
                                <l-control position="topright" v-show="isProgrammaticMove">
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn icon small tile v-bind="attrs" v-on="on" class="no-letter-space"
                                        @click="backToAmbulance()" style="
                                          background-color: white;
                                          border: solid;
                                          border-width: 2px;
                                          border-radius: 5px;
                                          border-color: #c2bfba;
                                          padding: 15px;
                                        ">
                                        <v-icon>mdi mdi-car-select</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>موقعیت آمبولانس</span>
                                  </v-tooltip>
                                </l-control>
                                <l-control position="topright" v-show="hasNewLocation">
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn icon small tile v-bind="attrs" v-on="on" class="no-letter-space"
                                        @click="backToMainPosition()" style="
                                          background-color: white;
                                          border: solid;
                                          border-width: 2px;
                                          border-radius: 5px;
                                          border-color: #c2bfba;
                                          padding: 15px;
                                        ">
                                        <v-icon>mdi-arrow-u-up-left</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>بازگشت به موقعیت ابتدایی</span>
                                  </v-tooltip>
                                </l-control>
                                <l-control position="bottomright" v-show="hasNewLocation">
                                  <v-btn small rounded dark color="darkColor" class="no-letter-space"
                                    @click="sendPationtNewLocationFunction()">
                                    تغییر موقعیت
                                  </v-btn>
                                </l-control>
                                <!-- path-markers -->
                                <l-marker v-if="currentZoom > 14" v-for="(item, index) in pathsList" :key="index"
                                  :lat-lng="[item.latitude, item.longitude]" :icon="getPathsIcon(item)">
                                  <l-popup>
                                    <section>
                                      <div class="flex-gap-1">
                                        <div>تاریخ و زمان :</div>
                                        <div>
                                          {{ getCurrentLocationTime(item?.date) }}
                                        </div>
                                      </div>
                                      <div class="flex-gap-1">
                                        <div>سرعت :‌</div>
                                        <div>KM/h</div>
                                        <div>
                                          {{ item?.speed.toFixed(2) }}
                                        </div>
                                      </div>
                                      <div class="flex-gap-1">
                                        <div>وضعیت :</div>
                                        <div>
                                          {{ item?.state ?? 'ندارد' }}
                                        </div>
                                      </div>
                                    </section>
                                  </l-popup>
                                </l-marker>
                                <!-- end l-marker paths -->
                                <l-marker ref="marker" v-if="phoneOnlineLocation?.latitude" :lat-lng="[
                                  phoneOnlineLocation.latitude,
                                  phoneOnlineLocation.longitude,
                                ]" :icon="getMovingIcon(phoneOnlineLocation)">
                                  <l-popup ref="popup">
                                    {{ phoneOnlineLocation?.phone?.code }}
                                  </l-popup>
                                </l-marker>
                                <l-marker v-if="
                                  patiantPosition && patiantPosition.lat && patiantPosition.lng
                                " visible :icon="icon" :lat-lng.sync="patiantPosition" @dragstart="dragingStart"
                                  @dragend="dragging = false" draggable></l-marker>
                                <l-marker v-if="
                                  confirmationLocation &&
                                  confirmationLocation?.lat & confirmationLocation?.lng
                                " :icon="confirmationIcon" :lat-lng.sync="confirmationLocation"></l-marker>
                              </l-map>
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="6">
                        <v-row>
                          <span>سابقه آدرس</span>
                          <v-divider class="mt-3 mr-2"></v-divider>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <edit-dialog-information-component v-if="editTab == 'address'"
                              :tableHeader="addressDataTableHeader" :tableItems="addressDataTableItems"
                              :height="'25vh'"></edit-dialog-information-component>
                          </v-col>
                        </v-row>
                        <v-row>
                          <span>سابقه موقعیت جغرافیایی</span>
                          <v-divider class="mt-3 mr-2"></v-divider>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <edit-dialog-information-component v-if="editTab == 'address'"
                              :tableHeader="locationConfiramtionTableHeader" :tableItems="missionConfirmations"
                              :height="'25vh'" @rowClick="showConfirmationLocation"
                              class="location-table"></edit-dialog-information-component>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="editTab == 'doctor'">
                <v-row>
                  <v-col class="doctor-part" cols="12" v-for="item in allDoctorOrders" :key="item.id">
                    <v-row class="mt-1">
                      <span class="mr-4">{{ item.patient }}</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="mt-4">
                        <edit-dialog-information-component :tableHeader="item.doctorInfoDataTableHeader"
                          :tableItems="item.doctorInfoDataTableItems"
                          :height="'10vh'"></edit-dialog-information-component>
                      </v-col>
                      <v-col cols="12" class="mt-4">
                        <edit-dialog-information-component :tableHeader="item.doctorDrugDataTableHeader"
                          :tableItems="item.doctorDrugDataTableItems"
                          :height="'30vh'"></edit-dialog-information-component>
                      </v-col>
                      <v-col cols="12" class="mt-4">
                        <edit-dialog-information-component :tableHeader="item.doctorOrderDataTableHeader"
                          :tableItems="item.doctorOrderDataTableItems"
                          :height="'30vh'"></edit-dialog-information-component>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="editTab == 'moreInfo'" class="moreInfoBox">
                <v-row>
                  <v-col class="my-5" cols="12">
                    <v-row>
                      <span class="mr-4">اطلاعات پذیرش</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                  </v-col>
                  <v-col class="moreInfo-part1" cols="12">
                    <v-row>
                      <v-col cols="12" class="mt-1">
                        <edit-dialog-information-component :tableHeader="admissionDataTableHeader"
                          :tableItems="admissionDataTableItems" :height="'20vh'"></edit-dialog-information-component>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col class="my-5" cols="12">
                    <v-row>
                      <span class="mr-4">ماموریت های پیوست شده</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                  </v-col>
                  <v-col class="moreInfo-part" cols="12">
                    <v-row>
                      <v-col cols="12" class="mt-1">
                        <v-data-table :headers="missionAttachDetailDataTableHeader"
                          :items="missionAttachDetailDataTableItems"
                          :items-per-page="missionAttachDetailDataTableItems.length" max-height="23vh"
                          :hide-default-footer="true" dense class="elevation-0 state-tabel tt table">
                          <template v-slot:no-data>
                            <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                          </template>
                          <template v-slot:[`item.otherPhoneNumber`]="{ item }">
                            <v-tooltip v-if="item.otherPhoneNumber != '-'" top>
                              <template v-slot:activator="{ on }">
                                <div class="itemCallPhone" v-on="on" @click="callToPatient(item.otherPhoneNumber)">
                                  {{ item.otherPhoneNumber }}
                                </div>
                              </template>
                              <span>تماس با {{ item.otherPhoneNumber }}</span>
                            </v-tooltip>
                            <div v-else class="itemCallPhone" v-on="on">
                              {{ item.otherPhoneNumber }}
                            </div>
                          </template>
                          <template v-slot:[`item.callerId`]="{ item }">
                            <v-tooltip v-if="item.callerId != '-'" top>
                              <template v-slot:activator="{ on }">
                                <div class="itemCallPhone" v-on="on" @click="callToPatient(item.callerId)">
                                  {{ item.callerId }}
                                </div>
                              </template>
                              <span>تماس با {{ item.callerId }}</span>
                            </v-tooltip>
                            <div v-else class="itemCallPhone" v-on="on">
                              {{ item.callerId }}
                            </div>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="editTab == 'otherOrgan'">
                <v-row>
                  <v-col cols="6">
                    <v-row class="mt-2">
                      <span class="mr-4">درخواست ها و پیشنهادات</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                  </v-col>
                  <v-col cols="6">
                    <v-row class="mt-2">
                      <span class="mr-4">سازمان های همکار انتخابی</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-row>
                      <v-col cols="12" v-for="item in allMissionOtherOrganizationRequests" :key="'s' + item.id">
                        <v-card elevation="0" class="other-organ-sugest-card-part">
                          <span class="other-organ-sugest-user">
                            {{ item.user.firstName }} {{ item.user.lastName }}
                          </span>
                          <v-card-text>
                            <v-row>
                              <v-chip small class="mr-2 mt-3 mb-3" v-for="subItem in item.requests"
                                :key="'wi' + subItem.id">
                                {{ subItem.otherOrganization.title }}
                              </v-chip>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="6">
                    <v-card height="50vh" elevation="0" class="other-organ-selected-card-part">
                      <v-card-text>
                        <v-row>
                          <v-col cols="12">
                            <v-autocomplete hide-details :items="allOtherOrganizationsForOther"
                              no-data-text="اطلاعاتی وجود ندارد" dense outlined item-text="title" item-value="id"
                              label="سازمان همکار" clearable clear-icon="mdi-close-circle-outline"
                              v-model="selectedOtherOrgan" autocomplete="off"
                              prepend-inner-icon="mdi-office-building mdi-18px">
                              <template v-slot:append-outer>
                                <v-btn x-small elevation="0" color="darkColor" class="py-5 mt-n2"
                                  @click="addSeletctedOtherOrgan()">
                                  <v-icon color="white">mdi-plus mdi-18px</v-icon>
                                </v-btn>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" class="mt-n2">
                            <v-row>
                              <v-col cols="6" v-for="item in allMissionOtherOrganizationInforms" :key="item.id">
                                <span class="mr-2 mt-2 other-organ-selected-span">
                                  {{ item.otherOrganization.title }}
                                  <v-icon class="mr-4" @click="deleteMissionOtherOrganizationInformFunction(item.id)">
                                    mdi-close-circle mdi-18px
                                  </v-icon>
                                </span>
                                <v-icon color="darkColor" class="mr-2"
                                  @click="callToOtherOrgan(item.otherOrganization.phoneNumber)">
                                  mdi-phone mdi-flip-h mdi-18px
                                </v-icon>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="editTab == 'calls'">
                <v-row class="mt-2">
                  <span class="mr-4">تماس ها</span>
                  <v-divider class="mt-3 mr-2"></v-divider>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <template>
                      <v-data-table :headers="misssionCallsInformationTableHeaders" :items="missionCallsDataTableInfo"
                        :items-per-page="missionCallsDataTableInfo.length" height="53vh" :hide-default-footer="true"
                        multi-sort class="elevation-0">
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon class="mt-1 mr-5" color="iconColor" style="cursor: pointer" v-bind="attrs"
                                @click="playAudioFunction(item.callLogId)" v-on="on">
                                mdi-play-circle
                              </v-icon>
                            </template>
                            <span>پخش صوت</span>
                          </v-tooltip>
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon class="mt-1 mx-2" color="iconColor" style="cursor: pointer"
                                @click="downloadAudioFunction(item.callLogId, item?.fromNumber)" v-bind="attrs"
                                v-on="on">
                                mdi-tray-arrow-down
                              </v-icon>
                            </template>
                            <span>دانلود</span>
                          </v-tooltip>
                        </template>
                        <template v-slot:no-data>
                          <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                        </template>
                      </v-data-table>
                    </template>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- <alert-component
      ref="snackRef"
      :snakTimeOut="snakTimeOut"
      :snackColor="snackColor"
      :snackText="snackText"
      :snakIcon="snakIcon"
    ></alert-component> -->
  </div>
</template>
<script>
import { latLng } from 'leaflet';
import L from 'leaflet';
import { LMap, LTileLayer, LMarker, LControl, LPopup } from 'vue2-leaflet';
import 'leaflet-ant-path';
import 'leaflet/dist/leaflet.css';
import Vue from 'vue';
import confirmDialog from '@/components/ConfirmDialog.vue';
import UserDetailComponent from '../UserDetailComponentNew.vue';
import EditDialogInformationComponent from '../115/EditDialogInformationComponent.vue';
import DispatchNoteComponent from '@/components/800/DispatchNoteComponent.vue';
import snackBar from '@/Mixins/snackBar.js';
import SharedMixin from '@/Mixins/Shared';
import SharedHelper from '@/Helpers/Shared';
import TagMixin from '@/Mixins/BaseInformation/TagMixin';
import CityMixin from '@/Mixins/BaseInformation/CityMixin';
import MissionPhonesMixin from '@/Mixins/Mission/MissionPhonesMixin';
import missionStateMixin from '@/Mixins/Mission/MissionStateMixin';
import MissionTranform from '@/Helpers/800/mission.transform';
import missionNoteMixin from '@/Mixins/Mission/MissionNoteMixin';
import HospitalMixin from '@/Mixins/BaseInformation/HospitalMixin';
import ZoneMixin from '@/Mixins/BaseInformation/ZoneMixin';
import SharedMap from '@/Mixins/map';
import DispatchCodeMixin from '@/Mixins/BaseInformation/DispatchCodeMixin';
import StationMixin from '@/Mixins/BaseInformation/StationMixin';
import MissionAddressLogMixin from '@/Mixins/Mission/MissionAddressLogMixin';
import MissionMixin from '@/Mixins/Mission/MissionMixin';
import PhoneOnlineLocationMixin from '@/Mixins/BaseInformation/PhoneOnlineLocationMixin';
import PatientDoctorDetailMixin from '@/Mixins/Doctor/PatientDoctorDetailMixin';
import CallMixin from '@/Mixins/Call/CallMixin';
import missionOtherOrganizationRequestMixin from '@/Mixins/Mission/MissionOtherOrganizationRequestMixin.js';
import missionOtherOrganizationInformMixin from '@/Mixins/Mission/MissionOtherOrganizationInformMixin.js';
import OtherOrganizationMixin from '@/Mixins/BaseInformation/OtherOrganizationMixin';
import GeographicalTypeMixin from '@/Mixins/BaseInformation/GeographicalTypeMixin';
import Edit800MissionHelper from '@/Helpers/800/Edit800MissionHelper.js';

import MissionReportHelper from '@/Helpers/Report/Shared/MissionReportHelper.js';

export default {
  name: 'Edit800Mission',
  title: 'ویرایش ماموریت',
  inject: ['load'],
  components: {
    UserDetailComponent,
    EditDialogInformationComponent,
    confirmDialog,
    DispatchNoteComponent,
    LMap,
    LTileLayer,
    LMarker,
    LControl,
    LPopup,
  },
  mixins: [
    Edit800MissionHelper,
    snackBar,
    SharedMixin,
    TagMixin,
    CityMixin,
    MissionPhonesMixin,
    missionStateMixin,
    missionNoteMixin,
    HospitalMixin,
    ZoneMixin,
    DispatchCodeMixin,
    StationMixin,
    MissionAddressLogMixin,
    MissionMixin,
    PhoneOnlineLocationMixin,
    PatientDoctorDetailMixin,
    CallMixin,
    missionOtherOrganizationRequestMixin,
    missionOtherOrganizationInformMixin,
    OtherOrganizationMixin,
    GeographicalTypeMixin,
    SharedHelper,
    MissionTranform,
    SharedMap,
    MissionReportHelper
  ],
  created() {
    this.$root.$refs.Edit800Mission = this;
  },
  mounted() {
    this.mounteLoding();
  },
  props: {
    missionId: {
      type: Number,
      require: true,
      default: null,
    },
    missionPhoneId: {
      type: Number,
      require: true,
      default: null,
    },
    missionCode: {
      type: String,
      require: true,
    },
    phoneCode: {
      type: String,
      require: true,
    },
    phoneId: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      zoom: 12,
      center: latLng(30.2839, 57.0834),
      mapTileUrl: '',
      attribution: '&copy; Asemantech',
      withPopup: latLng(30.2839, 57.0834),
      withTooltip: latLng(30.2839, 57.0834),
      currentZoom: 12,
      // currentCenter: latLng(30.2839, 57.0834),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        scrollWheelZoom: true,
      },
      patiantPosition: {},
      confirmationLocation: {},
      mainPationtPosition: {},
      dragging: false,
      icon: L.icon({
        iconUrl: require('@/assets/images/patient-location.svg'),
        iconSize: [35, 35],
      }),
      hasNewLocation: false,
      stoppedVehicleIcon: require('@/assets/images/stop_icon.svg'),
      confirmationIcon: L.icon({
        iconUrl: require('@/assets/images/patient-location-history-icon.svg'),
        iconSize: [35, 35],
      }),

      isProgrammaticMove: true,
    };
  },
  beforeDestroy() {
    try {
      clearInterval(this.mapSingleMovingIconInterval);
    } catch (error) {
      console.log("A error : ", error);
    }
  },
  methods: {
    handleEnterLack() {
      this.$nextTick(() => {
        if (this.selectedMissionLakeCode) {
          this.addMissionLakeCode();
        }
      });
    },
    mounte: function () {
      L.Icon.Default.mergeOptions({
        iconRetinaUrl: require('@/assets/images/marker-icon-2x.png'),
        iconUrl: require('@/assets/images/marker-icon.png'),
        shadowUrl: require('@/assets/images/marker-shadow.png'),
      });
      clearInterval(this.mapSingleMovingIconInterval);
      this.getListOfDispatchCodesForOther();
      this.getListOfCitysForOther();
      this.getListOfTagsForOther();
      this.getListOfAllActiveHospitalsFunction();
      this.getAllZones();
      this.getListOfStationsForOther();
      this.getAllGeographicalTypes();
      this.getMissionConfirmationFunction(this.missionId);
      this.setMapBaseSystemSetting();
    },
    centerUpdate(center) {
      // this.isProgrammaticMove = true
      this.$refs?.marker?.mapObject?.closePopup();
      this.currentCenter = center;
    },
    backToAmbulance() {
      // this.$refs?.marker?.mapObject?.openPopup();
      if (this.phoneOnlineLocation?.latitude && this.phoneOnlineLocation?.longitude) {
        this.$refs.modalmap?.mapObject?.flyTo(
          [this.phoneOnlineLocation?.latitude, this.phoneOnlineLocation?.longitude],
          16,
        );
      }
      // setTimeout(() => {
      //   this.isProgrammaticMove = false
      // }, 2000);
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    mapInvalidate: function () {
      setTimeout(() => {
        this.$refs.modalmap.mapObject.invalidateSize();
        this.$refs.modalmap?.mapObject?.flyTo(
          [this.patiantPosition?.lat, this.patiantPosition?.lng],
          16,
        );
      }, 100);
      setTimeout(() => {
        this.$refs?.marker?.mapObject?.openPopup();
      }, 300);
    },
    getMovingIcon(data) {
      if (data.isPhoneLocation == true) {
        //is phone
        if (data.hasMission == true) {
          return L.divIcon({
            className: 'my-custom-pin',
            html:
              '<img src="' +
              this.movingIconForPhoneWithMission +
              '" style="width:20px; height:20px; transform:rotate(' +
              data.angle +
              'deg)"/>',
          });
        } else if (data.hasMission == false) {
          return L.divIcon({
            className: 'my-custom-pin',
            html:
              '<img src="' +
              this.movingIconForPhoneWithOutMission +
              '" style="width:20px; height:20px; transform:rotate(' +
              data.angle +
              'deg)"/>',
          });
        }
      } else if (data.isPhoneLocation == false) {
        //is gps
        if (data.hasMission == true) {
          return L.divIcon({
            className: 'my-custom-pin',
            html:
              '<img src="' +
              this.movingIconForGPSWithMission +
              '" style="width:20px; height:20px; transform:rotate(' +
              data.angle +
              'deg)"/>',
          });
        } else if (data.hasMission == false) {
          return L.divIcon({
            className: 'my-custom-pin',
            html:
              '<img src="' +
              this.movingIconForGPSWithOutMission +
              '" style="width:20px; height:20px; transform:rotate(' +
              data.angle +
              'deg)"/>',
          });
        }
      }
    },
    getCurrentLocationTime: function (date) {
      return Vue.moment(date).format('jYYYY/jMM/jDD-HH:mm:ss');
    },
    showConfirmationLocation: function (item) {
      this.confirmationLocation = {
        lat: item.lat,
        lng: item.lng,
      };
      this.confirmationLocation = latLng(item?.latitude, item?.longitude);
    },
    getPathsIcon(data) {
      if (data?.speed > 3) {
        const iconImg = this.movingIconForGPSWithMission;
        return L.divIcon({
          className: 'my-custom-pin',
          html: `<img src="${iconImg}" style="width:15px; height:15px; transform:rotate(${data.bearing}deg)"/>`,
        });
      }
      const iconImg = this.stoppedVehicleIcon;
      return L.divIcon({
        className: 'my-custom-pin',
        html: `<img src="${iconImg}" style="width:30px; height:30px;transform:translateY(-160%)"/>`,
        iconAnchor: [-15, -45],
      });
    },
    ShowAntPath(latLngs) {
      const antPath = L.polyline.antPath(latLngs);
      antPath.addTo(this.$refs.modalmap.mapObject);
    },
    backToMainPosition: function () {
      this.patiantPosition = {
        lat: this.mainPationtPosition.lat,
        lng: this.mainPationtPosition.lng,
      };
      this.hasNewLocation = false;
    },
    dragingStart: function () {
      this.dragging = true;
      this.hasNewLocation = true;
    },
    addPationtNewPositionMarker(event) {
      this.hasNewLocation = true;
      this.patiantPosition = event.latlng;
    },
  },
  // watch: {
  //   missionInformation: function (newVal) {
  //     if (newVal.dispatchCurrentState === '10-19') {
  //       this.wasDispatchState1019 = true;
  //       // this.editMissionTenNineteenNote='10-19';
  //     }
  //     if (newVal.allow1019) this.was1019 = true;
  //   },
  // },
};
</script>
<style lang="scss" scoped>
.menu_topBox {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  gap: 20px;

  .itemMenu {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    text-align: center;
    white-space: nowrap;
  }

}

.location-table td {
  cursor: pointer !important;
}

.state-tabel {
  overflow: hidden;
}

.table thead {
  position: sticky;
  top: 0;
  z-index: 2;
}
</style>

<style scoped>
.itemCallPhone {
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  color: var(--dark-color);
}

.itemCallPhone:hover {
  background: #acacac;
}

.brnAction {
  min-width: 30px !important;
  width: 32px;
  margin: auto !important;
}

.menu-top-items {
  cursor: pointer !important;
}

.active-tab {
  color: var(--dark-color) !important;
  background: var(--background-color) !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border-radius: 5px !important;
}

.edit-modal-phones-card {
  max-height: 200px;
  overflow-y: auto;
}

.edit-modal-card-detail {
  border-radius: 12px !important;
  border: 1px solid var(--dark-color) !important;
}

.modal-title-text-menu {
  cursor: pointer;
}

.phone-numbers-items {
  background: var(--background-color) !important;
  border-radius: 5px !important;
  padding-right: 15px !important;
  padding-top: 6px !important;
  padding-bottom: 6px !important;
}

.phone-numbers-items-icon {
  background: var(--dark-color) !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  border-radius: 5px !important;
}

.edit-mission-main-card {
  overflow-y: auto;
  min-height: 525px;
  max-height: 90vh;
}

.note-box {
  border: 1px solid #909090 !important;
  border-radius: 12px !important;
}

.not-box-title {
  position: absolute;
  background: white;
  padding-right: 20px !important;
  margin-top: -1.4vh !important;
  margin-right: 45px !important;
}

.note-box-input {
  margin-top: 2.5vh !important;
}

.note-component-space {
  height: 47vh !important;
  overflow-y: auto !important;
}

.phone-code {
  color: var(--dark-color);
  margin-right: 5px !important;
}

.doctor-part {
  height: 68vh;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

.moreInfo-part {
  height: 25vh;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

.moreInfo-part1 {
  height: 22vh;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

.other-organ-selected-card-part {
  border: 1px solid var(--dark-color) !important;
  border-radius: 12px !important;
  overflow-y: auto;
  overflow-x: hidden;
}

.other-organ-sugest-card-part {
  border: 1px solid var(--dark-color) !important;
  border-radius: 12px !important;
}

.other-organ-sugest-user {
  position: absolute;
  margin-top: -12px;
  margin-right: 24px;
  padding-left: 8px;
  padding-right: 5px;
  background: white;
  font-size: 12px;
}

.other-organ-selected-span {
  background: var(--background-color) !important;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 5px;
  padding-bottom: 5px;
  border-radius: 30px !important;
  font-size: 12px;
}

>>>.v-data-table-header {
  background: var(--dark-color) !important;
}

>>>.state-tabel thead th:first-child {
  border-top-right-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
}

>>>.state-tabel thead th:last-child {
  border-top-left-radius: 8px !important;
  border-bottom-left-radius: 8px !important;
}

>>>.v-data-table-header tr th span {
  color: white !important;
}

>>>.state-tabel {
  border: 1px solid var(--light-color) !important;
  border-radius: 8px !important;
}

>>>.tt tbody tr:nth-of-type(even) {
  background-color: var(--background-color) !important;
}
</style>
